import { createFileRoute } from '@tanstack/react-router'
import { EmploymentCategoriesFeature } from '@/features/employment-categories/ui/EmploymentCategoriesFeature'

function EmploymentCategoriesPage() {
  return <EmploymentCategoriesFeature />
}

export const Route = createFileRoute('/settings/employment-categories/')({
  component: EmploymentCategoriesPage,
  staticData: { authorize: true },
})
